import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from "../../../../../redux/hooks/useTheme";
import { useUserDetails } from "../../../../../redux/hooks/UserDetails";
import { ArrowLeft } from "lucide-react";
import './Sidebar.css';

export default function Sidebar() {
    const { theme } = useTheme();
    const location = useLocation();
    const { userDetail } = useUserDetails();
    const isActive = (path: string) => {
        return location.pathname === path;
    };
    const navigate = useNavigate();

    return (
       <div className='side-bar-main w-full md:w-[200px] shrink-0 side-bar'>
         <div className="sticky top-[150px] side-bar">
            <div className="">
                <div className="max-w-7xl mx-auto">
                {/* <button className="flex items-center sidebar-sbtn" onClick={()=>navigate('/')}>
                    <ArrowLeft className="sidebar-sbtn sidebar-icon h-[16px] w-[16px] mr-2" />
                    <span>Back</span>
                </button> */}
                {/* <h1 className="sidebar-midbtn mt-4">My Profile</h1> */}
                </div>
           </div>
            <div style={{width:'200px', marginTop:'30px',height: 'calc(100vh - 155px)'}} className="border sidebar-bordre rounded-[20px] overflow-hidden sider-bar side-bar-mob side-bar-tab side-bar">
                <nav  className="flex flex-col nav-sidebar side-bar">
              <Link
                to="/accountSetting"
                className={`flex items-center sidebar-btn gap-3 px-4 prompt-on py-3 font-medium ${
                    isActive('/accountSetting') ? '' : 'text-gray-700'
                }`}
                style={{
                    color: theme.chatRightBarIcon,
                    background: isActive('/accountSetting')
                    ? `radial-gradient(31.91% 103.98% at 0% 46.15%, rgba(255, 58, 182, 0.05) 0%, rgba(251, 95, 101, 0.05) 40%, rgba(255, 255, 255, 0.05) 100%)`
                    : 'transparent',
                    borderLeft: isActive('/accountSetting') ? '2px solid #fd4e8b' : '2px solid transparent',
                }}
                >
                    <div className="flex items-center justify-center w-5 h-5">
                 
                   <span className='sidebar-icons'>
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 10H7C9 10 10 9 10 7V5C10 3 9 2 7 2H5C3 2 2 3 2 5V7C2 9 3 10 5 10Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M17 10H19C21 10 22 9 22 7V5C22 3 21 2 19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M17 22H19C21 22 22 21 22 19V17C22 15 21 14 19 14H17C15 14 14 15 14 17V19C14 21 15 22 17 22Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17V19C2 21 3 22 5 22Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                   </span>

                    </div>
                  <span className='Account Setting'> Account Settings</span>
                </Link>
                <Link 
                    to="/planinfo" 
                     className={`flex items-center sidebar-btn gap-3 px-4 prompt-on py-3 font-medium ${
                    isActive('/planinfo') ? '' : 'text-gray-700'
                }`}
                     style={{
                    color: theme.chatRightBarIcon,
                    background: isActive('/planinfo')
                    ? `radial-gradient(31.91% 103.98% at 0% 46.15%, rgba(255, 58, 182, 0.05) 0%, rgba(251, 95, 101, 0.05) 40%, rgba(255, 255, 255, 0.05) 100%)`
                    : 'transparent',
                    borderLeft: isActive('/planinfo') ? '2px solid #fd4e8b' : '2px solid transparent',
                }}
                >
                    <div className="flex items-center justify-center w-5 h-5">
                   
              <span className='sidebar-icon'>      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1083_10783)">
                    <g clip-path="url(#clip1_1083_10783)">
                    <path d="M4.85323 19.8343L2.47266 8.88001L7.23494 11.2617L11.9961 4.5943L16.7584 11.2617L21.5207 8.88001L19.1389 19.8332L4.85323 19.8343Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                    <path d="M12.0028 16.5017C12.253 16.5017 12.5007 16.4524 12.7319 16.3567C12.963 16.2609 13.173 16.1206 13.3499 15.9437C13.5268 15.7668 13.6672 15.5568 13.7629 15.3256C13.8587 15.0945 13.9079 14.8467 13.9079 14.5966C13.9079 14.3464 13.8587 14.0986 13.7629 13.8675C13.6672 13.6363 13.5268 13.4263 13.3499 13.2494C13.173 13.0725 12.963 12.9322 12.7319 12.8364C12.5007 12.7407 12.253 12.6914 12.0028 12.6914C11.4975 12.6914 11.0129 12.8921 10.6557 13.2494C10.2984 13.6067 10.0977 14.0913 10.0977 14.5966C10.0977 15.1018 10.2984 15.5864 10.6557 15.9437C11.0129 16.301 11.4975 16.5017 12.0028 16.5017Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                    </g>
                    </g>
                    <defs>
                    <clipPath id="clip0_1083_10783">
                    <rect width="24" height="24" fill="white"/>
                    </clipPath>
                    <clipPath id="clip1_1083_10783">
                    <rect width="24" height="24" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg></span>

                    </div>
                    Subscription
                </Link>

               {userDetail && userDetail.ogSubscriptionId  && 
                 <Link 
                    to="/billing" 
                     className={`flex items-center sidebar-btn gap-3 px-4 prompt-on py-3 font-medium ${
                    isActive('/billing') ? '' : 'text-gray-700'
                    }`}
                    style={{
                    color: theme.chatRightBarIcon,
                    background: isActive('/billing')
                    ? `radial-gradient(31.91% 103.98% at 0% 46.15%, rgba(255, 58, 182, 0.05) 0%, rgba(251, 95, 101, 0.05) 40%, rgba(255, 255, 255, 0.05) 100%)`
                    : 'transparent',
                    borderLeft: isActive('/billing') ? '2px solid #fd4e8b' : '2px solid transparent',
                }}
                >
                    <div className="flex items-center justify-center w-5 h-5">
                   
                    <span className='sidebar-icon'><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 6V8.42C22 10 21 11 19.42 11H16V4.01C16 2.9 16.91 2 18.02 2C19.11 2.01 20.11 2.45 20.83 3.17C21.55 3.9 22 4.9 22 6Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 7V21C2 21.83 2.94 22.3 3.6 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.29 22.29C8.68 22.68 9.32 22.68 9.71 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7H6C3 2 2 3.79 2 6V7Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 13.01H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 9.01001H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.99609 13H6.00508" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.99609 9H6.00508" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
</span>
                    </div>
                    Billing
                </Link>}
                </nav>
            </div>
       </div>
       </div>
    )}